import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-horizontal" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-7" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "col-2" }
const _hoisted_8 = { class: "card-footer" }
const _hoisted_9 = { class: "col text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", null, "Create promotion", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-info" }, "LinkAnytime", -1)
const _hoisted_13 = { class: "form-horizontal" }
const _hoisted_14 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_form_row = _resolveComponent("app-form-row")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_error = _resolveComponent("app-error")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_app_file_upload = _resolveComponent("app-file-upload")!
  const _component_app_simple_table = _resolveComponent("app-simple-table")!
  const _component_app_modal = _resolveComponent("app-modal")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Create Promotion Booster"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createVNode(_component_app_form_row, { label: "Name" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              modelValue: _ctx.model.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.name) = $event)),
              validations: _ctx.v$.name
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Promotion" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_app_select, {
                class: "col-10",
                modelValue: _ctx.model.promotionId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.promotionId) = $event)),
                modelModifiers: { number: true },
                options: _ctx.promotionOption,
                validations: _ctx.v$.promotionId
              }, null, 8, ["modelValue", "options", "validations"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_app_button, {
                  theme: "info",
                  icon: "fa-plus",
                  onClick: _withModifiers(_ctx.modalActions.openModal, ["prevent"])
                }, null, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Boosters" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_app_select, {
                  modelValue: _ctx.model.selectedBooster,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.selectedBooster) = $event)),
                  modelModifiers: { number: true },
                  options: _ctx.boosterOptionExcludeAdded
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_app_input, {
                  type: "number",
                  modelValue: _ctx.model.quantity,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.quantity) = $event)),
                  validations: _ctx.v$.quantity,
                  placeholder: "quantity"
                }, null, 8, ["modelValue", "validations"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_app_button, {
                  theme: "info",
                  icon: "fa-angle-double-down",
                  onClick: _withModifiers(_ctx.actions.addBoosterItem, ["prevent"])
                }, null, 8, ["onClick"])
              ])
            ]),
            _createVNode(_component_app_error, {
              validations: _ctx.v$.addedBoosterList
            }, null, 8, ["validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_table, {
          rows: _ctx.model.addedBoosterList,
          total: _ctx.model.addedBoosterList.length,
          columns: _ctx.table.columns,
          actions: _ctx.table.actions
        }, null, 8, ["rows", "total", "columns", "actions"]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_app_button, {
              name: "Create",
              theme: "info",
              icon: "fa-save",
              onClick: _withModifiers(_ctx.actions.create, ["prevent"])
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _createVNode(_component_app_modal, { name: _ctx.MODAL_NAME }, {
        default: _withCtx(() => [
          _hoisted_10,
          _hoisted_11,
          _createVNode(_component_app_form_row, { label: "Type" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createElementVNode("form", _hoisted_13, [
            _createVNode(_component_app_form_row, { label: "Name" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_input, {
                  modelValue: _ctx.promotionModel.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.promotionModel.name) = $event)),
                  validations: _ctx.promotionV$.name
                }, null, 8, ["modelValue", "validations"])
              ]),
              _: 1
            }),
            _createVNode(_component_app_form_row, { label: "Expected Package" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_input, {
                  type: "number",
                  modelValue: _ctx.promotionModel.expectedPackage,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.promotionModel.expectedPackage) = $event)),
                  modelModifiers: { number: true },
                  validations: _ctx.promotionV$.expectedPackage
                }, null, 8, ["modelValue", "validations"])
              ]),
              _: 1
            }),
            _createVNode(_component_app_form_row, { label: "Image" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_file_upload, {
                  modelValue: _ctx.promotionModel.imageFile,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.promotionModel.imageFile) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_app_form_row, {
              label: "Prototype",
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_select, {
                  modelValue: _ctx.promotionModel.prototypeId,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.promotionModel.prototypeId) = $event)),
                  modelModifiers: { number: true },
                  options: _ctx.promotionModel.prototypeOptions,
                  validations: _ctx.promotionV$.prototypeId
                }, null, 8, ["modelValue", "options", "validations"])
              ]),
              _: 1
            }),
            _createVNode(_component_app_simple_table, {
              items: _ctx.promotionModel.personas,
              fields: ['rfmPersonaName', 'packageId', 'price', 'credit', 'rate']
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_app_button, {
              name: "Create",
              theme: "success",
              onClick: _withModifiers(_ctx.createAccessUnlimitedPromotion, ["prevent"])
            }, null, 8, ["onClick"]),
            _createVNode(_component_app_button, {
              name: "Cancel",
              theme: "secondary",
              onClick: _withModifiers(_ctx.modalActions.closeModal, ["prevent"])
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["name"])
    ]),
    _: 1
  }))
}